import { render } from "./tpl_article.vue?vue&type=template&id=958b2e8a&scoped=true"
import script from "./tpl_article.vue?vue&type=script&lang=js"
export * from "./tpl_article.vue?vue&type=script&lang=js"

import "./tpl_article.vue?vue&type=style&index=0&id=958b2e8a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958b2e8a"],['__file',"src/views/dragger/template/tpl_article.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "958b2e8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('958b2e8a', __exports__)) {
    console.log('reload')
    api.reload('958b2e8a', __exports__)
  }
  
  module.hot.accept("./tpl_article.vue?vue&type=template&id=958b2e8a&scoped=true", () => {
    console.log('re-render')
    api.rerender('958b2e8a', render)
  })

}


export default __exports__